var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChooseFilterIconDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 11,
    viewBox: "0 0 16 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.22222 11H9.77778V9.16667H6.22222V11ZM0 0V1.83333H16V0H0ZM2.66667 6.41667H13.3333V4.58333H2.66667V6.41667Z",
    fill: "#ADADAD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.22222 11H9.77778V9.16667H6.22222V11ZM0 0V1.83333H16V0H0ZM2.66667 6.41667H13.3333V4.58333H2.66667V6.41667Z",
    stroke: "#ADADAD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChooseFilterIconDark);
export default __webpack_public_path__ + "static/media/choose-filter-icon-dark.3d1eed258cc5dd6e68de3f6df4b72663.svg";
export { ForwardRef as ReactComponent };